import { queryOptions } from '@tanstack/react-query';
import { getCurrentUser } from '../api/dashboardcurrentuser/methods';

/**
 * This object represents a call to dashboard/current-user-data.
 *
 * Since this call is quite expensive, we only enable setting it via setQueryData, and not via making new queries to the endpoint in question.
 */
export const dashboardCurrentUser = {
  keys: {
    currentUser: () => ['dashboard-current-user'],
  },
  // Methods
  get: () => queryOptions({
    queryKey: dashboardCurrentUser.keys.currentUser(),
    queryFn: () => getCurrentUser(),
    staleTime: Number.POSITIVE_INFINITY,
  }),
};
